if (!customElements.get("pdp-info-drawer-trigger")) {
  customElements.define(
    "pdp-info-drawer-trigger",
    class PdpInfoDrawerTrigger extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.pdpInfoDrawer = document.querySelector("pdp-info-drawer");
        if (!this.pdpInfoDrawer) return;
        this.addEventListener("click", this.openDrawer.bind(this));

        // Listen for custom event to reattach event listeners after content update
        document.addEventListener('pdpInfoDrawerContentUpdated', () => {
          this.pdpInfoDrawer = document.querySelector("pdp-info-drawer");
          console.log('Reattaching event listeners after drawer content update');
          this.addEventListener("click", this.openDrawer.bind(this));
        });
      }

      openDrawer() {
        console.log("Opening PDP info drawer");
        if (this.pdpInfoDrawer) {
          this.pdpInfoDrawer.open();
        }
        if (window.innerWidth < 750) {
          document.body.classList.add('overflow-hidden');
        }
      }
    }
  );
}

if (!customElements.get("pdp-info-drawer")) {
  customElements.define(
    "pdp-info-drawer",
    class PdpInfoDrawer extends HTMLElement {
      constructor() {
        super();

        this.movedWidget = null;
        this.widgetPlaceholder = null;
        this.originalParent = null;
        this.originalNextSibling = null;
        this.observer = null;
      }

      connectedCallback() {
        this.productGroup = this.querySelector('.pdp-info-drawer__product-group product-group');

        if (this.productGroup) {
          this.productGroup.addEventListener('click', this.handleSwatchClick.bind(this));
        }

        this.initBVListener();
        this.initScrollShadow();
      }

      initScrollShadow() {
        const content = this.querySelector('.pdp-info-drawer__content');
        if (!content) return;

        const update = () => {
          const canScroll = content.scrollHeight - content.clientHeight > 1;
          const atBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 1;
          this.classList.toggle('has-bottom-shadow', canScroll && !atBottom);
        };

        content.addEventListener('scroll', update, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          this.scrollShadowObserver = new ResizeObserver(update);
          this.scrollShadowObserver.observe(content);
          Array.from(content.children).forEach((child) => this.scrollShadowObserver.observe(child));
        }

        update();
      }

      moveRechargeWidgetIntoDrawer() {
        const widget = document.querySelector('.shopify-block.recharge-subscription-widget');
        const container = this.querySelector('.pdp-info-drawer__blocks');

        if (!widget || !container) return;
        if (this.movedWidget) return;

        this.movedWidget = widget;

        this.originalParent = widget.parentNode;
        this.originalNextSibling = widget.nextSibling;

        this.widgetPlaceholder = document.createElement('div');
        this.widgetPlaceholder.className = 'recharge-widget-placeholder';
        this.widgetPlaceholder.innerHTML = 'Loading...';

        widget.replaceWith(this.widgetPlaceholder);

        container.prepend(widget);
      }

      restoreRechargeWidget() {
        if (!this.movedWidget || !this.originalParent) return;

        if (this.originalNextSibling) {
          this.originalParent.insertBefore(this.movedWidget, this.originalNextSibling);
        } else {
          this.originalParent.appendChild(this.movedWidget);
        }

        if (this.widgetPlaceholder) {
          this.widgetPlaceholder.remove();
        }

        this.movedWidget = null;

        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      handleSwatchClick(event) {
        event.preventDefault();

        const swatch = event.target.closest('.button-swatch');
        if (!swatch) return;

        const swatchLink = swatch.querySelector('a');
        if (!swatchLink) return;

        const hasRecharge = document.querySelector('recharge-subscription-widget');

        if (hasRecharge) {
          window.location.href = swatchLink.href;
          return;
        }
        
        this.fetchDrawerContent(swatchLink.href);
      }

      async fetchDrawerContent(url) {
        try {
          const separator = url.includes('?') ? '&' : '?';
          const response = await fetch(url + `${separator}sections=pdp-info-drawer`);
          const text = await response.text();
          const data = JSON.parse(text);
          console.log('Fetched drawer content:', data);

          const sectionHTML = data["pdp-info-drawer"];
          if (!sectionHTML) {
            console.error("Drawer section missing", data);
            return;
          }

          // Convert HTML string → DOM
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(sectionHTML, "text/html");

          // Get the new section
          const newSection = newDoc.querySelector("#shopify-section-pdp-info-drawer");
          const currentSection = document.querySelector("#shopify-section-pdp-info-drawer");

          if (!newSection || !currentSection) return;

          // Preserve open state
          const wasOpen = currentSection.querySelector('pdp-info-drawer')?.classList.contains('is-open');

          // Replace ENTIRE section
          currentSection.replaceWith(newSection);

          requestAnimationFrame(() => {
          const drawer = document.querySelector('#shopify-section-pdp-info-drawer pdp-info-drawer');
          if (!drawer) return;

          if (wasOpen) {
            // 1. prevent animation
            drawer.classList.add('no-animate');
            drawer.classList.add('is-open');

            // 2. force browser to apply styles immediately
            drawer.getBoundingClientRect();

            // 3. re-enable animation for future closes/opens
            requestAnimationFrame(() => {
              drawer.classList.remove('no-animate');
            });
          }

          // dispatch event to trigger to reattach event listeners
          const event = new CustomEvent('pdpInfoDrawerContentUpdated', { bubbles: true });
          drawer.dispatchEvent(event);
        });
        } catch (error) {
          console.error('Error fetching drawer content:', error);
        }
      }

      open() {
        this.classList.add("is-open");

        this.moveRechargeWidgetIntoDrawer();

        if (window.innerWidth < 750) {
          document.body.classList.add('overflow-hidden');
        } else {
          this.initHeroObserver();
        }
      }

      close() {
        this.classList.remove("is-open");

        this.restoreRechargeWidget();

        if (window.innerWidth < 750) {
          document.body.classList.remove('overflow-hidden');
        }

        if (this.heroObserver) {
          this.heroObserver.disconnect();
          this.heroObserver = null;
        }
      }

      initHeroObserver() {
        const hero = document.querySelector('.product-hero-section');
        if (!hero) return;

        if (this.heroObserver) return;

        this.heroObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];

            if (entry.intersectionRatio < 0.2) {
              this.close();
            }
          },
          {
            threshold: [0.2]
          }
        );

        this.heroObserver.observe(hero);
      }

      initBVListener() {
        const el = this.querySelector('[data-bv-show="rating_summary"]');
        if (!el) return;

        const observer = new MutationObserver(() => {
          const isReady = el.getAttribute('data-bv-ready') === 'true';

          if (isReady && !el.dataset.listenerAttached) {
            el.dataset.listenerAttached = 'true';

            el.addEventListener('click', () => {
              this.close();
            });

            observer.disconnect();
          }
        });

        observer.observe(el, {
          attributes: true,
          attributeFilter: ['data-bv-ready']
        });
      }
    }
  );
}